<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 0.75C9.5 0.335786 9.16421 0 8.75 0C8.33579 0 8 0.335786 8 0.75L8 8H0.75C0.335786 8 0 8.33579 0 8.75C0 9.16421 0.335786 9.5 0.75 9.5H8V16.75C8 17.1642 8.33579 17.5 8.75 17.5C9.16421 17.5 9.5 17.1642 9.5 16.75V9.5H16.75C17.1642 9.5 17.5 9.16421 17.5 8.75C17.5 8.33579 17.1642 8 16.75 8H9.5L9.5 0.75Z"
      fill="url(#paint0_linear_3136_2873)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3136_2873"
        x1="-8.73708"
        y1="8.73708"
        x2="8.73708"
        y2="26.2112"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00FFAA" />
        <stop offset="0.517251" stop-color="#4579F5" />
        <stop offset="0.999815" stop-color="#9C42F5" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "PlusIcon",
})
</script>
